import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBilling = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 15,
	fill: "none",
	viewBox: "0 0 19 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.808 15c-.505 0-.933-.175-1.283-.525A1.745 1.745 0 0 1 0 13.192V1.808C0 1.303.175.875.525.525.875.175 1.303 0 1.808 0h15.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v11.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H1.808ZM1.5 7.096h16V3.904h-16v3.192Z" })
});
export { SvgBilling as ReactComponent };
